import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[420px] sm:min-h-[500px] md:min-h-[600px] lg:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20colorful%20collection%20of%20sneakers%20in%20soft%20pastel%20tones%20arranged%20neatly%20on%20white%20shelves%20soft%20natural%20daylight%20minimalist%20streetwear%20store%20display%20editorial%20photography%20clean%20aesthetic%20warm%20gentle%20lighting%20high%20detail&width=1600&height=900&seq=hero-bg-02&orientation=landscape"
          alt="AllChinaBuy fashion products collection"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80 sm:from-black/60 sm:via-black/40 sm:to-black/70" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-16 sm:py-20 md:py-28 lg:py-32">
        <div className="max-w-3xl animate-slide-up">
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6 text-balance">
            {t('hero.title')}
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-white/90 mb-3 md:mb-4 font-medium">
            {t('hero.subtitle')}
          </p>
          <p className="text-sm sm:text-base md:text-base text-white/80 leading-relaxed mb-6 md:mb-8 max-w-2xl">
            {t('hero.description')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-6">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 md:px-8 md:py-4 bg-primary-500 text-background-50 font-medium text-sm md:text-base rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t('hero.cta_primary')}
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 md:px-8 md:py-4 bg-white/15 backdrop-blur-sm text-white font-medium text-sm md:text-base rounded-md border border-white/30 hover:bg-white/25 transition-colors whitespace-nowrap"
            >
              {t('hero.cta_secondary')}
              <i className="ri-book-open-line" />
            </a>
          </div>

          <p className="text-xs md:text-sm text-white/60 flex items-center gap-2">
            <i className="ri-shield-check-line" />
            {t('hero.trust')}
          </p>
        </div>
      </div>
    </section>
  );
}